import {
    SYSTEM_SUBMIT_INDUSTRYTYPE_BEGIN,
    SYSTEM_SUBMIT_INDUSTRYTYPE_SUCCESS,
    SYSTEM_SUBMIT_INDUSTRYTYPE_FAILURE,
    SYSTEM_SUBMIT_INDUSTRYTYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitIndustryType(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_INDUSTRYTYPE_BEGIN,
      });
  
      let apiurl = '/api/b/industryType/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/industryType/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_INDUSTRYTYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_INDUSTRYTYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitIndustryTypeError() {
    return {
      type: SYSTEM_SUBMIT_INDUSTRYTYPE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_INDUSTRYTYPE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitIndustryTypePending: true,
          submitIndustryTypeError: null,
        };
  
      case SYSTEM_SUBMIT_INDUSTRYTYPE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitIndustryTypePending: false,
          submitIndustryTypeError: null,
        };
  
      case SYSTEM_SUBMIT_INDUSTRYTYPE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitIndustryTypePending: false,
          submitIndustryTypeError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_INDUSTRYTYPE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitIndustryTypeError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitIndustryType.js